import React from "react";
import { FaFacebookF } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";

function Footer() {
  return (
    <div className="w-full bg-black">
      <div className="w-full max-w-[1300px] m-auto flex justify-between items-center md:px-6 px-4 pt-6 pb-4">
        <p className="font-noto text-white font-[400] text-sm  ">
          Copyright © Shop4Them 2023
        </p>
        <div className="flex justify-center items-center gap-4">
          <a href="">
            <FaFacebookF color="white" className="transition-all duration-300 hover:scale-110" />
          </a>
          <a href="">
            <FaInstagram color="white" className="transition-all duration-300 hover:scale-110" />
          </a>
          <a href="">
            <FaTwitter color="white" className="transition-all duration-300 hover:scale-110" />
          </a>
          <a href="">
            <FaLinkedinIn color="white" className="transition-all duration-300 hover:scale-110" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Footer;
